(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const setupSlider = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('[data-lux-slide]')];
    const dots = [...root.querySelectorAll('[data-lux-to]')];
    const pause = root.querySelector('[data-lux-pause]');
    let current = 0, timer, paused = root.dataset.auto !== 'true' || reduced.matches;
    const stop = () => clearInterval(timer);
    const paintPause = () => {
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? pause.dataset.play : pause.dataset.pause);
      pause.textContent = paused ? '▷' : 'Ⅱ';
      root.classList.toggle('is-paused', paused);
    };
    const show = n => {
      current = (n + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
        slide.inert = i !== current;
        slide.setAttribute('aria-hidden', String(i !== current));
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
      root.querySelector('[data-lux-counter]').textContent = String(current + 1).padStart(2, '0');
    };
    const start = () => { stop(); if (!paused && !document.hidden) timer = setInterval(() => show(current + 1), 7000); };
    const select = n => { paused = true; stop(); paintPause(); show(n); };
    root.querySelector('[data-lux-next]').addEventListener('click', () => select(current + 1));
    root.querySelector('[data-lux-prev]').addEventListener('click', () => select(current - 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => select(i)));
    pause.addEventListener('click', () => { paused = !paused; paintPause(); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', e => { if (!root.contains(e.relatedTarget)) start(); });
    document.addEventListener('visibilitychange', start);
    reduced.addEventListener('change', () => { if (reduced.matches) { paused = true; paintPause(); stop(); } });
    show(0); paintPause(); start();
  };
  document.querySelectorAll('[data-lux-slider]').forEach(setupSlider);
  document.querySelectorAll('[data-lux-share]').forEach(root => {
    const status = root.querySelector('[role=status]');
    const copy = async () => {
      try { await navigator.clipboard.writeText(root.dataset.url); status.textContent = root.dataset.copied; }
      catch { root.querySelector('details').open = true; root.querySelector('input').select(); status.textContent = root.dataset.copyFailed; }
    };
    root.querySelector('[data-lux-copy]').addEventListener('click', copy);
    root.querySelector('[data-lux-native-share]').addEventListener('click', async () => {
      if (!navigator.share) return copy();
      try { await navigator.share({ title: root.dataset.title, url: root.dataset.url }); }
      catch (error) { if (error.name !== 'AbortError') await copy(); }
    });
  });
  document.querySelectorAll('.lux-review-form').forEach(form => {
    form.addEventListener('submit', () => {
      const body = form.querySelector('textarea[name="comment[body]"]');
      const rating = form.querySelector('[data-review-rating]').value;
      body.value = `Rating: ${rating}/5\n${body.value.replace(/^Rating: [1-5]\/5\s*/, '')}`;
    });
  });
  if ('IntersectionObserver' in window) {
    const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-seen'); reveal.unobserve(entry.target); }
    }), { threshold: 0.08 });
    document.querySelectorAll('[data-lux-reveal]').forEach(el => reveal.observe(el));
    document.documentElement.classList.add('lux-ready');
    const relatedObserver = new IntersectionObserver(entries => entries.forEach(async entry => {
      if (!entry.isIntersecting) return;
      const root = entry.target;
      relatedObserver.unobserve(root);
      try {
        const response = await fetch(root.dataset.url, { credentials: 'same-origin' });
        if (!response.ok) return;
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = parsed.querySelector('[data-related-results][data-recommendations="ready"]');
        if (content) root.querySelector('[data-related-results]').replaceWith(content);
      } catch {}
    }), { rootMargin: '300px' });
    document.querySelectorAll('[data-lux-related]').forEach(el => relatedObserver.observe(el));
  }
  document.querySelectorAll('[data-lux-motion]').forEach(button => button.addEventListener('click', () => {
    const paused = button.closest('section').classList.toggle('is-paused');
    button.setAttribute('aria-pressed', String(paused));
    button.textContent = paused ? button.dataset.play : button.dataset.pause;
  }));
})();
